import cn from 'classnames'
import PropTypes from 'prop-types'
import { createUseStyles } from '../helpers/createStyles'

const CategoryTitle = ({ children, className }) => {
  const styles = useStyles()
  return <span className={cn(styles.root, className)}>{children}</span>
}

const useStyles = createUseStyles({
  root: {
    opacity: 1,
    color: '#566160',
    fontSize: '10px',
    lineHeight: 1.2,
    letterSpacing: '1px',
    textTransform: 'uppercase'
  }
})

CategoryTitle.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string
}

export default CategoryTitle
